// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__PPtG6","tab":"Tabs_tab__XgOst","tabActive":"Tabs_tabActive__3BPHk"};